export default {
  namespaced: true,
  state: () => ({
    user: {
      id: null,
      nome: null,
      email: null,
      role: null,
      usuario_login_alternativo: null,
      status: null,
      created_at: null,
      updated_at: null,
    },
    accessToken: null,
    refreshToken: null,
    user_permissions: [],
    isLoading: false,
    userAuth: {},
  }),
  mutations: {
    SET_USER(state, payload) {
      localStorage.setItem('userData', JSON.stringify(payload));
      state.user = payload.userData;
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
    },
    SET_USER_PERMISSIONS(state, payload) {
      localStorage.setItem('userPermissions', JSON.stringify(payload));
      state.user_permissions = payload;
    },
    SET_ACCESS_TOKEN(state, payload) {
      localStorage.setItem('accessToken', payload);
      state.accessToken = payload;
    },
    SET_REFRESH_TOKEN(state, payload) {
      localStorage.setItem('refreshToken', payload);
      state.refreshToken = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_USER_AUTH(state, payload) {
      state.userAuth = payload;
    },
  },
  getters: {
    GET_USER(state) {
      const userLocal = JSON.parse(localStorage.getItem('userData')) || state.user;
      return {
        ...userLocal,
        permissions: state.user_permissions,
      };
    },
    GET_USER_PERMISSIONS(state) {
      return JSON.parse(localStorage.getItem('userPermissions')) || state.user_permissions;
    },
    IS_LOGGED_IN(state) {
      const userLocal = JSON.parse(localStorage.getItem('userData')) || state.user;
      return userLocal.id !== null;
    },
    GET_ACCESS_TOKEN(state) {
      return localStorage.getItem('accessToken') || state.accessToken;
    },
    GET_REFRESH_TOKEN(state) {
      return localStorage.getItem('refreshToken') || state.refreshToken;
    },
    GET_IS_LOADING(state) {
      return state.isLoading;
    },
    GET_USER_AUTH(state) {
      return state.userAuth;
    },
  },
  actions: {
    LOGOUT_USER({ commit, dispatch }) {
      commit('SET_USER', {
        id: null,
        nome: null,
        email: null,
        role: null,
        usuario_login_alternativo: null,
        status: null,
        created_at: null,
        updated_at: null,
      });
      commit('SET_USER_PERMISSIONS', []);
      commit('SET_ACCESS_TOKEN', null);
      commit('SET_REFRESH_TOKEN', null);
      localStorage.removeItem('userData');
      localStorage.removeItem('userPermissions');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      // Remover estado persistido do PTC_Pedidos
      localStorage.removeItem('estado');

      // Limpar itens do carrinho ao fazer logout
      dispatch('cart/clearCart', null, { root: true });
      // Limpar pedidos ao fazer logout
      dispatch('PedidosStore/clearPedidoAndItemPedido', null, { root: true });
    },
  },
};
